<template>
    <sys-register-base 
        :loading="loading" 
        @onSave="save" 
        :model.sync="model" 
        :title="title" 
        :icon="icon"
        v-bind:show.sync="dialog"
        maxWidth="40%"
    >
        <template v-slot:form>

            <v-tabs class="ma-0" v-model="tab">
                <v-tab key="main">Dados</v-tab>
                <v-tab key="address" v-if="model.id">Endereço</v-tab>
            </v-tabs>
            <v-tabs-items  v-model="tab">
                <v-tab-item key="main">
                     <v-container>
                        <v-row>
                            <v-col cols="12" sm="12">
                                <v-text-field autofocus :error="!!errors.name" :error-messages="errors.name" v-model="model.name" label="Nome*"></v-text-field>
                            </v-col>
                            
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="6">
                                <v-text-field :error="!!errors.initials" :error-messages="errors.initials" v-model="model.initials" label="Sigla*"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3">
                                <s-text-field code :error-messages="errors.code" v-model="model.code" label="Código" />
                            </v-col>
                            <v-col cols="12" sm="3">
                                <s-text-field :error-messages="errors.identifier_code" v-model="model.identifier_code" label="Identificador" />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="8">
                                <s-text-field :error-messages="errors.company_name" v-model="model.company_name" label="Razão Social" />
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-text-field v-mask-cnpj :error-messages="errors.cnpj" v-model="model.cnpj" label="Cnpj" />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="12">
                                <v-textarea
                                    :error="!!errors.description" 
                                    :error-messages="errors.description" 
                                    v-model="model.description" 
                                    label="Descrição"
                                    :counter="255"
                                    rows="2"
                                    :rules="[v => (!v || v.length <= 255) || 'Máximo de 255 caracteres atingido']"
                                    outlined
                                    clearable
                                />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="4">
                                <sys-select-brand
                                    :model.sync="model.brand_id"
                                    label="Marca"
                                    clearable
                                />
                            </v-col>
                            <v-col cols="12" sm="4">
                                <s-switch inset v-model="model.generate_time_sheet" label="Folha de Ponto" />
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-switch color="purple" inset v-model="model.active" label="Ativo"></v-switch>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-tab-item>
                <v-tab-item key="address">
                    <v-container>
                        <v-row>
                            <v-col cols="12" sm="12">
                                <sys-address-register :model.sync="model" type='company' />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-tab-item>
            </v-tabs-items>    
            <!-- Alert para mensagens -->
            <emc-alert-snackbar :show="!! message.length"  :message="message" :color="error ? 'error' : 'success'"/>
        </template>
    </sys-register-base>
</template>

<script>

import { mapActions, mapState } from 'vuex'
export default {
    name: "SysRegisterCompany",
    data: (vm) => ({
        tab: 0,
        dialog: false,
        error: false,
        errors: {},
        range: null,
        message: '',
        loading: false,
    }),
    created(){
       
    },

    computed: {
      ...mapState('auth', ['acesso']),
    },

    watch: {
        
        dialog(dialog_new, dialog_old) {
            
            if(dialog_new !== dialog_old) {
                this.$emit('update:show', dialog_new)
            }

        },

        show(show_new, show_old) {
            
            this.dialog = show_new;
            
            if(show_new){
                
                this.error = false;
                this.errors = {};
                this.range = null;
                this.tab = 0;

                if(!this.model.id){
                    this.model.active = 1;
                }

            }
        },
        
    },
    props: {
        model: {
            default: null
        },
        color: {
            type: String,
            default: 'grey lighten-5'
        },
        width: {
            type: String,
            default: "500"
        },
        maxWidth: {
            type: String,
            default: "80%"
        },
        icon: {
            type: String,
            default: "mdi-database-plus"
        },
        title: {
            type: String,
            default: "Cadastro"
        },
        text: {
            type: String,
            default: ""
        },
        show: {
            type: Boolean,
            default: false
        }
    },
    methods:{
        ...mapActions('paymentExport', ['ActionUpdateCompany', 'ActionCreateCompany']),

        save(edit)
        {
            this.error = false;
            this.message = '';
            this.loading = true;

            if(edit) {
                this.ActionUpdateCompany(this.model)
                .then((res) => {
                    this.message = res.message;
                    this.$emit('onCompleted');
                })
                .catch((error) =>{
                    this.error      = true;
                    this.errors     = error.errors;
                    this.message    = error.message;
                })
                .finally(() => {
                     this.loading = false;
                })
            } else {
                this.ActionCreateCompany(this.model)
                .then((res) => {
                    this.message = res.message;
                    this.$emit('onCompleted', res.data);
                })
                .catch((error) =>{
                    this.error      = error;
                    this.errors     = error.errors;
                    this.message    = error.message;
                })
                .finally(() => {
                   this.loading = false;
                })

            }
        },
    }
}
</script>